module.exports = __webpack_public_path__ + "img/5.b457c44c.png";